import { render, staticRenderFns } from "./IOManagementDetails.vue?vue&type=template&id=a2724ad2&scoped=true&"
import script from "./IOManagementDetails.vue?vue&type=script&lang=js&"
export * from "./IOManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./IOManagementDetails.vue?vue&type=style&index=0&id=a2724ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2724ad2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardActions,VCol,VDialog,VIcon,VImg,VRow,VSpacer,VTextarea})
